export default __webpack_public_path__ + "static/media/w.de0fcf24.svg";